import '@/assets/main.css'

import App from '@/App.vue'
import { RollbarPlugin } from '@/lib/rollbar_init'
import { routes, scrollBehavior, setupRouter } from '@/router'
import { ViteSSG, type ViteSSGOptions } from 'vite-ssg'

export const createApp = ViteSSG(App, { routes, scrollBehavior }, ({ app, router }) => {
  if (!import.meta.env.SSR) {
    app.use(RollbarPlugin(import.meta.env.VITE_APP_VERSION as string | undefined))
  }

  setupRouter(router)
})

export const includedRoutes: ViteSSGOptions['includedRoutes'] = async (paths) => {
  const { proTipArticles, proTipBooks } = await import('@/res/protips')
  const { blogArticles } = await import('@/res/blog')
  const articles = Array.from(proTipArticles.keys(), (key) => `/protips/${key}`)
  const books = Array.from(proTipBooks.keys(), (key) => `/protips/books/${key}`)
  const blogs = Array.from(blogArticles.keys(), (key) => `/blog/${key}`)

  const knownSections = new Set<string>()
  for (const article of proTipArticles.values()) {
    if (article.attributes.section) {
      knownSections.add(article.attributes.section)
    }
  }
  const sections = Array.from(knownSections, (slug) => `/protips/s/${slug}`)

  // Same logic as `DefaultIncludedRoutes` in vite-ssg package
  const staticPaths = paths.filter((i) => i !== '/index.html' && !i.includes(':') && !i.includes('*'))

  return [...staticPaths, ...sections, ...articles, ...books, ...blogs, '/404']
}
